import createStore from 'unistore';
import CONSTANT from '../utils/constants';
import { getKey } from '../utils/common';

const cache = (function _cache() {
  let cacheInstances = {};

  class Cache {
    caches = {};

    getData = (key, defaultVal) => {
      return getKey(this.caches, key, defaultVal);
    };

    setData = (key, value) => {
      if (!key) {
        return;
      }

      this.caches[key] = value;
    };

    clear = () => {
      this.caches = {};
    };
  }

  function create(instanceKey) {
    instanceKey = instanceKey || CONSTANT.DEFAULT_INSTANCE_KEY;
    return (cacheInstances[instanceKey] = new Cache());
  }

  function getInstance(instanceKey) {
    instanceKey = instanceKey || CONSTANT.DEFAULT_INSTANCE_KEY;
    return cacheInstances[instanceKey];
  }

  function clearInstance(instanceKey) {
    instanceKey = instanceKey || CONSTANT.DEFAULT_INSTANCE_KEY;
    delete cacheInstances[instanceKey];
  }

  function clear() {
    cacheInstances = {};
  }

  return {
    create,
    getInstance,
    clearInstance,
    clear
  };
})();

export default cache;

export const globaleStore = createStore({});



// WEBPACK FOOTER //
// ./common/cache.js